import { useRef } from "react";
import HeroSection from "../components/home/HeroSection";
import Affiliations from "../components/home/Affiliations";
import Founder from "../components/home/Founder";

import Footer from "../components/shared/Footer";
import OurBusiness from "../components/home/OurBusiness/Index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Home = () => {
  const businessSectionRef = useRef(null);

  const scrollTo = () => {
    
    if (businessSectionRef.current) {
      businessSectionRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="flex flex-col">
      <ToastContainer />
      <HeroSection scrollFunc={scrollTo} />
      <OurBusiness businessSectionRef={businessSectionRef} />
      
      {/* <Business businessSectionRef={businessSectionRef} /> */}
      <Affiliations />
      <Founder />
      {/* <MediaAnnouncements /> */}
      {/* <ContactFooter /> */}
      <Footer />
    </div>
  );
};

export default Home;
